module.exports = __webpack_public_path__ + "static/media/colored-email.95d4ea18.svg";